"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Button_1 = require("../Button");
const StyledContainer = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
`;
function Options({ icon, items, title, variant, onUpdate, }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: [
            {
                type: 'custom',
                value: title,
                children: ((0, jsx_runtime_1.jsx)(StyledContainer, { children: items.map((element) => {
                        return ((0, jsx_runtime_1.jsx)(Button_1.Button, { variant: element.variant, onClick: (data) => onUpdate(Object.assign(Object.assign({}, data), { action: element.action })), icon: element.icon && Object.assign(Object.assign({}, element.icon), { size: 'Small' }), title: element.variant === 'tooltip' && element.titleKey
                                ? `${t(element.titleKey)}`
                                : undefined }, `option-${element.id}`));
                    }) })),
            },
        ], placement: "bottom", trigger: "click", children: (0, jsx_runtime_1.jsx)(Button_1.Button, { icon: icon, title: title, variant: variant, onClick: (event) => event && event.preventDefault() }) }));
}
exports.Options = Options;
//# sourceMappingURL=Options.js.map